import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import ReportsHeader from '../../../components/Reports/ReportsHeader';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { getOvertimeListMasterReport } from '../../../store/ReportsDetailsSlice/actions';
import { useSelector } from 'react-redux';
import { selectOvertimeListMasterReportData } from '../../../store/ReportsDetailsSlice/selectors';
import ReusableGrid from '../../../components/Grid';

const HEADERS = [
  {
    headerName: 'Employee',
    field: 'employee',
  },
  {
    headerName: 'Phone',
    field: 'phone',
  },
  {
    headerName: 'List',
    field: 'list',
  },
  {
    headerName: 'Seniority',
    field: 'seniority',
  },
  {
    headerName: 'Hours',
    field: 'hours',
  },
];

const createRowsStructure = (arr) =>
  arr.map((arrRow, rowIndex) => {
    const rowObj = { id: rowIndex };
    HEADERS.forEach((header, i) => {
      if (typeof arrRow[i] === 'string' && arrRow[i].trim() === '()')
        return (rowObj[header.field] = '-');
      rowObj[header.field] = arrRow[i];
    });
    return rowObj;
  });

const ReportOvertimeListMaster = () => {
  const dispatch = useDispatch();
  const { isLoadingOvertimeListMasterReport, overtimeListMasterReport } =
    useSelector(selectOvertimeListMasterReportData);

  const fireRows = useMemo(
    () => createRowsStructure(overtimeListMasterReport.FIRE),
    [overtimeListMasterReport.FIRE]
  );
  const rescueRows = useMemo(
    () => createRowsStructure(overtimeListMasterReport.RESCUE),
    [overtimeListMasterReport.RESCUE]
  );

  console.log({ fireRows, rescueRows });
  useEffect(() => {
    dispatch(getOvertimeListMasterReport());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper className="p-4" sx={{ marginTop: '1rem' }}>
      <ReportsHeader title="Overtime List Master Report Details" />
      <Box>
        {isLoadingOvertimeListMasterReport ? (
          <Box
            sx={{ minHeight: '30px' }}
            className="w-10 h-10 d-flex justify-content-center align-items-center"
          >
            <CircularProgress size={32} />
          </Box>
        ) : (
          <>
            <Box mb={8}>
              <Typography mb={2} component="h2" fontWeight={600} variant="h4">
                Rescue Division
              </Typography>

              <ReusableGrid rows={rescueRows} columns={HEADERS} />
            </Box>

            <Box>
              <Typography mb={2} component="h2" fontWeight={600} variant="h4">
                Fire Division
              </Typography>

              <ReusableGrid rows={fireRows} columns={HEADERS} />
            </Box>
          </>
        )}
      </Box>
    </Paper>
  );
};

export default ReportOvertimeListMaster;
